import { Container, Row, Col, Form } from "react-bootstrap";
import { useRef, useState, useEffect } from "react";
import "../../../App.css";
import "../../../css/bootstrap.scss";
import reg_entity from "../../../images/create_entity_ques1_icon1.png";
import tick from "../../../images/tick.png";
import cross from "../../../images/cross.png";
import BackButton from "../../Includes/BackButtonEntityAccount";
import { Field, reduxForm, InjectedFormProps } from "redux-form";
import renderField from "../../renderField";
import { connect } from "react-redux";
import {
  setEmail,
  setwizardPageNumber,
  setwizardPageName,
  setUserID,
  setEntityAccountUserDetails,
  setEntityAccountBusinessDetails,
} from "../../EntityAccountReducer";
import { RootState } from "../../store";
import { useDispatch, useSelector } from "react-redux";
import { ToastBox, notifyError } from "MyComponents/Toaster";
import Spacer from "MyComponents/UI/Spacer";
import { updateEntityKycDraftStep } from "Utils/entityKycDraft";
import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

interface Props { }

const CreateEntityThirdQues: React.FC<
  Props & InjectedFormProps<{}, Props, FormData>
> = (props: any) => {
  const { handleSubmit } = props;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const page = useSelector(
    (state: RootState) => state.entityAccount.wizardPageNumber
  );
  const entityAccountBusinessDetails = useSelector(
    (state: RootState) => state.entityAccount.entityAccountBusinessDetails
  );
  const userID = useSelector((state: RootState) => state.entityAccount.userID);

  useEffect(() => {
    dispatch(setwizardPageName("eligibilityC"));
  }, [dispatch]);

  const onClickYes = async () => {
    const updatedObject = {
      ...entityAccountBusinessDetails,
      AuthorizedRepresentative: "1",
    };
    try {
      if (userID) {
        await updateEntityKycDraftStep(userID, 'EntityAccountUser', { isAuthorizedRepresentative: "1" });
      }
      dispatch(setEntityAccountBusinessDetails(updatedObject));
      dispatch(setwizardPageNumber(page + 1));
      localStorage.setItem('pageNumber', `${page + 1}`);
    } catch (error) {
      console.error("Draft update error:", error);
      notifyError("Failed to save progress.");
    }
  };

  return (
    <>
      <Container fluid className="min-vh-custom mt-4">
        <Row className="px-3 px-md-5">
          <Col md={12} className="text-center mt-3 justify-content-center">
            <img src={reg_entity} width={50} />
            <h3 className="text-center mt-3">
              {t('kyc.auth_rep_company_q')}
            </h3>
            <Row className="justify-content-center">
              <Col md={6}>
                <p className="text-secondary small mt-3">
                  {t('kyc.auth_rep_company_desc')}
                </p>
              </Col>
            </Row>
            <Row className="justify-content-center py-3">
              <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  onClick={onClickYes}
                  sx={{
                    flexDirection: "column",
                    py: 3,
                    px: 4,
                    borderRadius: 4,
                    minWidth: 140,
                    bgcolor: "#e3f2fd",
                    color: "#1976d2",
                    "&:hover": { bgcolor: "#bbdefb" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 8px rgba(25, 118, 210, 0.12)",
                  }}
                >
                  <img src={tick} alt="Yes" width={40} />
                  <Typography sx={{ mt: 1.5, fontWeight: "bold" }}>
                    {t('common.yes')}
                  </Typography>
                </Button>
 
                <Button
                  sx={{
                    flexDirection: "column",
                    py: 3,
                    px: 4,
                    borderRadius: 4,
                    minWidth: 140,
                    bgcolor: "#ffebee",
                    color: "#d32f2f",
                    "&:hover": { bgcolor: "#ffcdd2" },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxShadow: "0px 2px 8px rgba(211, 47, 47, 0.12)",
                  }}
                >
                  <img src={cross} alt="No" width={40} />
                  <Typography sx={{ mt: 1.5, fontWeight: "bold" }}>
                    {t('common.no')}
                  </Typography>
                </Button>
              </Stack>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  initialValues: {
    AuthorizedRepresentative: state.entityAccount.entityAccountBusinessDetails.AuthorizedRepresentative || "",
  },
});

const form = reduxForm<{}, Props, FormData>({
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  form: "entityWizard",
  enableReinitialize: true,
})(CreateEntityThirdQues);

export default connect(mapStateToProps)(form);
